ACC.preferencesSPA = {

    _autoload: [
        ['init', document.getElementById('preference-wrapper')],
    ],

    wrapperId: 'preference-wrapper',

    init() {
        ACC.preferencesSPA.waitForPreferencesWrapper('.preference-wrapper', () => {
            ACC.preferencesSPA.replaceTextWithGlobalMSG();
        });
        const host = document.getElementById(ACC.preferencesSPA.wrapperId).getAttribute('data-env');
        const props = {
            host,
            onUpdate: ACC.preferencesSPA.updateHandler,
            onSuccess: ACC.preferencesSPA.successHandler,
            onCancel: ACC.preferencesSPA.cancelHandler,
            onError: ACC.preferencesSPA.errorHandler,
        };

        window.createPreferenceOptions(ACC.preferencesSPA.wrapperId, props);
    },

    waitForPreferencesWrapper(wrapper, callback) {
        if ($(wrapper).length) {
            callback();
        } else {
            setTimeout(() => {
                this.waitForPreferencesWrapper(wrapper, callback);
            }, 200);
        }
    },

    updateHandler() {
        ACC.preferencesSPA.showPrimaryBtn(true);
    },

    successHandler() {
        ACC.preferencesSPA.showPrimaryBtn(false);

        const globalMessageRequestSuccess = {
            globalMessages: [{
                messageHolder: 'accConfMsgs',
                messages: ['text.preferences.successes'],
            }],
        };

        ACC.globalmessages.createGlobalMessage(globalMessageRequestSuccess);
    },

    cancelHandler() {
        window.location = document.getElementById(ACC.preferencesSPA.wrapperId).getAttribute('data-homepage');
    },

    errorHandler() {
        ACC.preferencesSPA.showPrimaryBtn(false);

        const globalMessageRequestError = {
            globalMessages: [{
                messageHolder: 'accErrorMsgs',
                messages: ['text.preferences.error'],
            }],
        };

        ACC.globalmessages.createGlobalMessage(globalMessageRequestError);
    },

    showPrimaryBtn(show) {
        const btn = document.querySelector('.button__v2__primary__bordered');
        if (show) {
            btn.classList.add('disable');
        } else {
            btn.classList.remove('disable');
        }
    },

    replaceTextWithGlobalMSG() {
        const marketingFisrtOption = $('div.pt-1 .toggle-option-child:first-of-type .toggle-option-title.col-10');
        const marketingSecondOption = $('div.pt-1 .toggle-option-child:last-of-type .toggle-option-title.col-10');
        const privacyProfilingText = $('.mb-4.toggle-option-description');

        marketingFisrtOption.html(ACC.config.upcMarketingDescriptionText);
        marketingSecondOption.html(ACC.config.upcThirdPartyMarketingDescriptionText);
        privacyProfilingText.html(ACC.config.upcPrivacyUserProfilingText);
    },
};
